var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":"","color":"black"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"pa-2",style:(_vm.icon.meta.author !== 'Google'
          ? 'border-radius: 4px; border-style: solid; border-color: coral; border-width: 1px'
          : ''),attrs:{"color":_vm.color},on:{"click":_vm.downloadSvg}},'v-icon',attrs,false),on),[_vm._v(_vm._s(_vm.icon.icon)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.icon.meta.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }